import { Auth, User as AuthUser } from 'firebase/auth';
import { GetUserByIdInteractor } from './get-user-by-id.interactor';
import { FailedError, NotFoundError, User } from '@uploadcam/common';
import { Subject } from 'rxjs';

export function getAuthUser(
  auth: Auth,
  userAuthStateChanged$: Subject<AuthUser | undefined>,
): Promise<AuthUser | null> {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(
      (user) => {
        unsubscribe();
        resolve(user);
        userAuthStateChanged$.next(user ?? undefined);
      },
      () => {
        unsubscribe();
        reject(new FailedError('There was an issue while getting the Firebase Auth state.'));
      },
    );
  });
}

export class GetUserInteractor {
  constructor(
    private readonly auth: Auth,
    private readonly getUserById: GetUserByIdInteractor,
    private readonly userAuthStateChanged$: Subject<AuthUser | undefined>,
    private readonly userGetCurrent$: Subject<User>,
  ) {}

  public async execute(): Promise<User> {
    const authUser = await getAuthUser(this.auth, this.userAuthStateChanged$);

    if (!authUser) {
      throw new NotFoundError();
    }

    const user = await this.getUserById.execute(authUser.uid);
    this.userGetCurrent$.next(user);

    return user;
  }
}
